module.exports = __webpack_public_path__ + "./docs/img/icon-folder-open.249b9a09abf0e1927ab844d2698e248a.svg";